import { publicEnv } from "@/config/publicEnv";

const DEFAULT_PRODUCT_IMAGE_BASE_URL = "https://media.axiommanifold.com/product-images";

export function productImageBaseUrl(): string {
  return (publicEnv.s3ImagesUrl || DEFAULT_PRODUCT_IMAGE_BASE_URL).replace(/\/+$/, "");
}

export function productImageUrl(imagePath?: string | null): string {
  const trimmed = (imagePath || "placeholder.svg").trim();

  if (/^(https?:)?\/\//i.test(trimmed) || trimmed.startsWith("data:") || trimmed.startsWith("blob:")) {
    return trimmed;
  }

  if (trimmed.startsWith("/images/") || trimmed.startsWith("/_next/")) {
    return trimmed;
  }

  return `${productImageBaseUrl()}/${trimmed.replace(/^\/+/, "")}`;
}

export function localProductImageFallback(imagePath?: string | null): string {
  const trimmed = (imagePath || "placeholder.svg").trim();
  const filePath = /^(https?:)?\/\//i.test(trimmed)
    ? trimmed.split("/").pop() || "placeholder.svg"
    : trimmed.replace(/^\/+/, "") || "placeholder.svg";

  return DEFAULT_PRODUCT_IMAGE_BASE_URL+`/${filePath}`;
}
//https://media.axiommanifold.com/product-images/2026/06/0753-1.webp
